module.exports = __webpack_public_path__ + "static/img/14-03.327bbd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/14-03.png
// module id = SnZG
// module chunks = 0